import { FormEvent, useState } from 'react';
import { Breadcrumbs } from '../../Home/Breadcrumb';
import { CognitoService } from '../../../services/CognitoService';

export const SincronizarModulo = () => {
  const [add, setAdd] = useState('');
  const [deleteValue, setDeleteValue] = useState('');
  const [emails, setEmails] = useState('');
  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState('');
  const [error, setError] = useState('');

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    setResultado('');
    setError('');

    try {
      const message = await CognitoService.sincronizarModulos({
        add,
        delete: deleteValue,
        emails,
      });
      setResultado(message || 'Sincronizacion completada correctamente.');
    } catch (err: any) {
      const message =
        err?.response?.data || 'No se pudo ejecutar la sincronizacion.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-page">
      <div className="content">
        <div className="container-fluid">
          <Breadcrumbs title="Sincronizar modulo Cognito" />

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={onSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Add (opcional)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={add}
                        onChange={(e) => setAdd(e.target.value)}
                        placeholder="Ej: PONCHO,IND"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Delete (opcional)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={deleteValue}
                        onChange={(e) => setDeleteValue(e.target.value)}
                        placeholder="Ej: OLD_TAG"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Emails (opcional)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={emails}
                        onChange={(e) => setEmails(e.target.value)}
                        placeholder="Ej: user@test.com,otro@test.com"
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? 'Procesando...' : 'Sincronizar modulos'}
                    </button>
                  </form>

                  {resultado && (
                    <div className="alert alert-success mt-3 mb-0" role="alert">
                      {resultado}
                    </div>
                  )}

                  {error && (
                    <div className="alert alert-danger mt-3 mb-0" role="alert">
                      {error}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
